import type {
  IItemSelectedBundleOptionValue,
  ISelectedBundleOptionValue,
  SelectedBundleOptionValue,
} from "@magento/types";

export const areBundleOptionsFromCart = (
  options: SelectedBundleOptionValue[]
): options is ISelectedBundleOptionValue[] => options.length > 0 && "label" in options[0];

export const areBundleOptionsFromOrder = (
  options: SelectedBundleOptionValue[]
): options is IItemSelectedBundleOptionValue[] => options.length > 0 && "product_name" in options[0];
